import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledHealthcareLocationTimetablePreferencesForm = styled(StyledFlex)`
   padding: 2px 0;
`;
